import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { mobileDeviceFullStore } from '../store/store';
import MobileDeviceDetails from './MobileDeviceDetails';
import MobileDeviceLogging from './MobileDeviceLogging';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { CommandButton, IconButton, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode, DetailsListLayoutMode, ColumnActionsMode, CheckboxVisibility, } from 'office-ui-fabric-react/lib/DetailsList';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Selection } from 'office-ui-fabric-react/lib/Selection';
import { toggleDeviceLoggingWindow } from '../mutators/toggleDeviceLoggingWindow';
import { toggleDeviceLoggingEnabled } from '../mutators/toggleDeviceLoggingEnabled';
import { markIsDevicesDirty } from '../mutators/markIsDevicesDirty';
import { markIsNotSendReadReceiptDirty } from '../mutators/markIsNotSendReadReceiptDirty';
import { markIsLoggingEnabledDirty } from '../mutators/markIsLoggingEnabledDirty';
import { updateNotSendReadReceipt } from '../mutators/updateNotSendReadReceipt';
import { selectMobileDevice } from '../mutators/selectMobileDevice';
import { deleteMobileDevice } from '../mutators/deleteMobileDevice';
import { initMobileDeviceFullOption } from '../orchestrators/initMobileDeviceFullOption';
import strings from 'owa-strings/owa-options-strings';
import EditButton from './EditButton';
var styles = require('./MobileDeviceFull.scss');
var MobileDeviceFull = /** @class */ (function (_super) {
    tslib_1.__extends(MobileDeviceFull, _super);
    function MobileDeviceFull(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelectionChanged = function () {
            var selectedIndices = _this.selection.getSelectedIndices();
            if (selectedIndices.length > 0) {
                selectMobileDevice(selectedIndices[0]);
            }
            else {
                var store = mobileDeviceFullStore();
                if (store.selected >= 0) {
                    selectMobileDevice(-1);
                }
            }
        };
        _this.getKey = function (item, index) {
            return index;
        };
        _this.onDeviceLoggingClicked = function () {
            toggleDeviceLoggingEnabled();
            toggleDeviceLoggingWindow();
            markIsLoggingEnabledDirty(true);
        };
        _this.onSendReceiptChanged = function (ev, checked) {
            updateNotSendReadReceipt(checked);
            markIsNotSendReadReceiptDirty(true);
        };
        _this.onRenderRow = function (props, defaultRender) {
            if (defaultRender) {
                return React.createElement("div", { className: styles.row }, defaultRender(props));
            }
            return null;
        };
        _this.onRemoveDevice = function () {
            var store = mobileDeviceFullStore();
            if (store.selected >= 0) {
                deleteMobileDevice(store.selected);
                markIsDevicesDirty(true);
            }
        };
        _this.onGetOutlookAppClicked = function () {
            window.open('https://go.microsoft.com/fwlink/?linkid=870116');
        };
        _this.onRenderItemColumn = function (item, index, column) {
            if (column.key === 'command') {
                return (React.createElement("div", { className: styles.commandCol },
                    React.createElement(EditButton, { index: index }),
                    React.createElement(IconButton, { buttonType: ButtonType.command, onClick: _this.onRemoveDevice, iconProps: { iconName: "Delete" /* Delete */ }, className: styles.command, title: strings.options_mobile_full_deleteButton }),
                    React.createElement(IconButton, { buttonType: ButtonType.command, onClick: initMobileDeviceFullOption, iconProps: { iconName: "Refresh" /* Refresh */ }, className: styles.command, title: strings.options_mobile_full_refreshButton }),
                    mobileDeviceFullStore().isLoggingEnabled ? (React.createElement(IconButton, { buttonType: ButtonType.command, onClick: _this.onDeviceLoggingClicked, iconProps: { iconName: "PageRemove" /* PageRemove */ }, className: styles.command, title: strings.options_mobile_full_disableLoggingButton })) : (React.createElement(IconButton, { buttonType: ButtonType.command, onClick: _this.onDeviceLoggingClicked, iconProps: { iconName: "PageEdit" /* PageEdit */ }, className: styles.command, title: strings.options_mobile_full_enableLoggingButton }))));
            }
            return item[column.key];
        };
        _this.selection = new Selection({
            onSelectionChanged: _this.onSelectionChanged,
            getKey: _this.getKey,
        });
        return _this;
    }
    Object.defineProperty(MobileDeviceFull.prototype, "columns", {
        get: function () {
            return [
                {
                    key: 'deviceType',
                    fieldName: 'deviceType',
                    name: strings.options_mobile_full_deviceColumn,
                    minWidth: 100,
                    maxWidth: 150,
                    isResizable: false,
                    columnActionsMode: ColumnActionsMode.disabled,
                    className: styles.detailsListColumn,
                    headerClassName: styles.detailsListHeader,
                },
                {
                    key: 'phoneNumber',
                    fieldName: 'phoneNumber',
                    name: strings.options_mobile_full_phoneNumberColumn,
                    minWidth: 100,
                    maxWidth: 150,
                    isResizable: false,
                    columnActionsMode: ColumnActionsMode.disabled,
                    className: styles.detailsListColumn,
                    headerClassName: styles.detailsListHeader,
                },
                {
                    key: 'status',
                    fieldName: 'status',
                    name: strings.options_mobile_full_statusColumn,
                    minWidth: 100,
                    maxWidth: 150,
                    isResizable: false,
                    columnActionsMode: ColumnActionsMode.disabled,
                    className: styles.detailsListColumn,
                    headerClassName: styles.detailsListHeader,
                },
                {
                    key: 'command',
                    fieldName: 'Command',
                    name: '',
                    minWidth: 150,
                    maxWidth: 250,
                    isResizable: false,
                    columnActionsMode: ColumnActionsMode.disabled,
                    className: styles.detailsListColumn,
                    headerClassName: styles.detailsListHeader,
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    MobileDeviceFull.prototype.render = function () {
        var store = mobileDeviceFullStore();
        if (store.isDetailsOpen) {
            return (React.createElement(MobileDeviceDetails, { deviceDetails: store.selected >= 0 ? store.devices[store.selected] : null }));
        }
        else if (store.isLoggingOpen) {
            return React.createElement(MobileDeviceLogging, null);
        }
        else {
            return (React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement(Label, { className: styles.title }, strings.options_mobile_full_title)),
                React.createElement(DetailsList, { className: styles.detailsList, items: store.devices, columns: this.columns, selection: this.selection, selectionMode: SelectionMode.single, layoutMode: DetailsListLayoutMode.justified, selectionPreservedOnEmptyClick: true, checkboxVisibility: CheckboxVisibility.hidden, onRenderRow: this.onRenderRow, onRenderItemColumn: this.onRenderItemColumn }),
                React.createElement(Checkbox, { className: styles.readReceipt, label: strings.options_mobile_full_readReceiptCheckbox, checked: store.notSendReadReceipt, onChange: this.onSendReceiptChanged }),
                React.createElement(CommandButton, { onClick: this.onGetOutlookAppClicked, iconProps: { iconName: "OutlookLogoInverse" /* OutlookLogoInverse */ }, className: styles.getOutlookAppLink, text: strings.options_mobile_get_outlook_appButton })));
        }
    };
    MobileDeviceFull = tslib_1.__decorate([
        observer
    ], MobileDeviceFull);
    return MobileDeviceFull;
}(React.Component));
export default MobileDeviceFull;
//# sourceMappingURL=MobileDeviceFull.js.map